import axios from 'axios';
import { login, logout } from 'services/auth.service';

const version = 'v1';
const basePath = 'user';

export async function getMe() {
  return axios.request({
    url: `/${version}/${basePath}/me`,
    method: 'get',
  });
}

export async function getEfficiency() {
  return axios.request({
    url: `/${version}/${basePath}/efficiency/`,
    method: 'get',
  });
}

export async function getAll({ group, page = 1, itemsPerPage = 100 }) {
  return axios.request({
    url: `/${version}/${basePath}/list`,
    method: 'get',
    params: {
      order_by: 'id',
      order_mode: 'desc',
      ...(!!group?.length && {
        group: {
          in: group.join(','),
        },
      }),
      limit: itemsPerPage,
      skip: itemsPerPage * (page - 1),
    },
  });
}

export async function setWarehouse(userId, warehouse_id) {
  return axios.request({
    url: `/${version}/${basePath}/${userId}/set-warehouse/`,
    method: 'put',
    data: {
      warehouse_id,
    },
  });
}

export async function unsetWarehouse(userId) {
  return axios.request({
    url: `/${version}/${basePath}/${userId}/unset-warehouse/`,
    method: 'delete',
  });
}

export async function setMarketplace(userId, warehouse_id) {
  return axios.request({
    url: `/${version}/${basePath}/${userId}/set-marketplace/`,
    method: 'put',
    data: {
      warehouse_id,
    },
  });
}

export async function unsetMarketplace(userId, marketplace_id) {
  return axios.request({
    url: `/${version}/${basePath}/${userId}/unset-marketplace/${marketplace_id}`,
    method: 'put',
  });
}

export async function update(data) {
  const { id, ...rest } = data;
  return axios.request({
    url: `/${version}/${basePath}/${id}/full-configure/`,
    method: 'put',
    data: {
      ...rest,
    },
  });
}

export async function createAPIUser(username, password) {
  await login(username, password);
  await getMe();
  await logout();
}
